import { clsx } from 'clsx';
import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { streamTag } from '@/components/streams/stream-tag/stream-tag.css.ts';

export const StreamTag: FC<
  {
    icon?: ReactNode;
  } & ComponentPropsWithoutRef<'div'>
> = ({ icon, className, children, ...props }) => {
  return (
    <div className={clsx(streamTag, className)} {...props}>
      {icon}
      {children}
    </div>
  );
};
